(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount"] && !Shopify.designMode) return;
  try {
    if (!window.misyDiscountApplyBound) {
  window.misyDiscountApplyBound = true;
  const applyDiscount = (input) => {
    if (!input) return;
    input.blur();
    const field = input.closest('cart-discount-field');
    if (!input.value.trim() || field.getAttribute('aria-busy') === 'true') return;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.misy-discount-apply');
    if (!button) return;
    event.preventDefault();
    applyDiscount(button.closest('.misy-discount-entry').querySelector('input:not([type="hidden"])'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.isComposing || event.keyCode === 229 || event.key !== 'Enter' || !event.target.matches('cart-discount-field input:not([type="hidden"])')) return;
    event.preventDefault();
    applyDiscount(event.target);
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-gift-box-upsell-assets"] && !Shopify.designMode) return;
  try {
    if (!window.misyCartGiftBoxUpsellBound) {
    window.misyCartGiftBoxUpsellBound = true;

    document.addEventListener("click", async (event) => {
      const button = event.target.closest("[data-cart-gift-box-add]");

      if (!button || button.getAttribute("aria-busy") === "true") {
        return;
      }

      event.preventDefault();
      const errorMessage = button.closest('[data-misy-cart-gift]')?.querySelector('[data-misy-gift-error]');
      if (errorMessage) { errorMessage.hidden = true; errorMessage.textContent = ''; }

      const variantId = Number.parseInt(button.getAttribute("data-gift-box-variant-id"), 10);
      const quantity = Number.parseInt(button.getAttribute("data-gift-box-quantity") || "1", 10);
      const propertyName = button.getAttribute("data-gift-box-property-name");
      const propertyValue = button.getAttribute("data-gift-box-property-value");

      if (!Number.isFinite(variantId)) {
        return;
      }

      button.setAttribute("aria-busy", "true");
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

      try {
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

        const giftBoxItem = {
          id: variantId,
          quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1
        };

        if (propertyName && propertyValue) {
          giftBoxItem.properties = {
            [propertyName]: propertyValue
          };
        }

        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({
            items: [giftBoxItem],
            sections: sectionsToBundle.join(","),
            sections_url: `${Shopify.routes.root}cart`
          })
        });

        const responseJson = await response.json();

        if (!response.ok) {
          throw new Error(responseJson.description || "Gift box add failed");
        }

        if (button.dataset.cartGiftContext === 'page') {
          // The full cart does not rerender on cart:refresh. Remove only the
          // automatically granted BOX before loading the final line items.
          const currentResponse = await fetch(`${Shopify.routes.root}cart.js`);
          if (!currentResponse.ok) throw new Error('Cart confirmation failed');
          const currentCart = await currentResponse.json();
          const autoBoxes = currentCart.items.filter((item) => item.handle === 'gift-box-solo' && item.properties?._auto_gift === 'true');
          for (const item of autoBoxes) {
            const removed = await fetch(`${Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
            if (!removed.ok) throw new Error('Gift BOX confirmation failed');
          }
          window.location.reload();
          return;
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            onSuccessDo: "force_open_drawer",
            cart: cartContent
          }
        }));
      } catch (error) {
        if (errorMessage) {
          errorMessage.hidden = false;
          errorMessage.textContent = '追加結果を確認できませんでした。カートを更新して内容をご確認ください。';
        }
      } finally {
        button.removeAttribute("aria-busy");
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lovely-necklace-visual-picker"] && !Shopify.designMode) return;
  try {
    if (!window.misyLovelyNecklacePickerBound) {
    window.misyLovelyNecklacePickerBound = true;

    const setCurrentCard = (picker, optionValue) => {
      picker.querySelectorAll("[data-lovely-option-value]").forEach((item) => {
        item.setAttribute("aria-pressed", item.getAttribute("data-lovely-option-value") === optionValue ? "true" : "false");
      });
    };

    const scrollToMedia = (picker, mediaId) => {
      const carouselId = picker.getAttribute("data-carousel-id");
      const carousel = carouselId ? document.getElementById(carouselId) : picker.closest("product-gallery")?.querySelector(".product-gallery__carousel");
      const media = carousel?.querySelector(`[data-media-id="${mediaId}"]`);

      if (media) {
        media.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    };

    document.addEventListener("click", (event) => {
      const button = event.target.closest("[data-lovely-option-value]");

      if (!button) {
        return;
      }

      const picker = button.closest("[data-lovely-picker]");
      const formId = picker?.getAttribute("data-form-id");
      const optionValue = button.getAttribute("data-lovely-option-value");
      const mediaId = button.getAttribute("data-lovely-media-id");
      const input = formId ? document.querySelector(`input[form="${CSS.escape(formId)}"][data-option-position="1"][value="${CSS.escape(optionValue)}"]`) : null;

      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (picker) {
        setCurrentCard(picker, optionValue);
      }

      if (picker && mediaId) {
        scrollToMedia(picker, mediaId);
      }
    });

    document.addEventListener("change", (event) => {
      const input = event.target;

      if (!input.matches('input[data-option-position="1"][form]')) {
        return;
      }

      document.querySelectorAll(`[data-lovely-picker][data-form-id="${CSS.escape(input.getAttribute("form"))}"]`).forEach((picker) => {
        setCurrentCard(picker, input.value);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["misy-shopping-benefits"] && !Shopify.designMode) return;
  try {
    if (!window.misyCouponCopyBound) {
    window.misyCouponCopyBound = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-misy-copy-code]');
      if (!button) return;
      const code = button.dataset.misyCopyCode;
      if (code !== 'SET10' && code !== 'SET15') return;
      const status = button.closest('.misy-benefits').querySelector('.misy-benefits__status');
      try {
        await navigator.clipboard.writeText(code);
        status.textContent = code + 'をコピーしました。クーポン欄に貼り付けてください。';
      } catch {
        status.textContent = 'コピーできませんでした。' + code + 'をクーポン欄に入力してください。';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
